import MobileNavView from "components/shared/views/MobileNavView";
import AccountDetailsModal from "./AccountDetailsModal";
import AddUnlinkedTransferAccountModal from "./AddUnlinkedTransferAccountModal";
import ChatEndSessionModal from "./ChatEndSessionModal";
import DeleteEmailModal from "./DeleteEmailModal";
import DeletePhoneModal from "./DeletePhoneModal";
import EDEHistoryModal from "./EDEHistoryModal";
import EDEStatementModal from "./EDEStatementModal";
import EDEAssociateNoticesModal from "./EDEAssociateNoticesModal";
import FirstTimeLoginModal from "./FirstTimeLoginModal";
import MakeAPaymentModal from "./MakeAPaymentModal";
import ReviewTransferModal from "./ReviewTransferModal";
import TestModal from "./TestModal";
import AddContactMethodModal from "./AddContactMethodModal";
import CheckImagePreviewModal from "components/custom-ui/FullPageModal/components/CheckImagePreviewModal";
import MobileAccountDetailsModal from "./MobileAccountDetailsModal";
import OneTimeACHModal from "./OneTimeACHModal";
import ACHParticipantsModal from "./ACHParticipantsModal";
import PassThruACHDetailsModal from "./PassThruACHDetailsModal";
import TransactionInquiryModal from "./TransactionInquiryModal";
import TASPositivePayCancelAddCheckModal from "./TASPositivePayCancelAddCheckModal";
import MenuModal from "../../../MenuModal/MenuModal";

export default {
    "TestModal" : TestModal,
    "MakeAPaymentModal" : MakeAPaymentModal,
    "AccountDetailsModal" : AccountDetailsModal, 
    "AddUnlinkedTransferAccountModal" : AddUnlinkedTransferAccountModal,
    "ChatEndSessionModal" : ChatEndSessionModal, 
    "MobileNavView" : MobileNavView,
    "ReviewTransferModal" : ReviewTransferModal,
    "EDEAssociateNoticesModal" : EDEAssociateNoticesModal,
    "EDEHistoryModal" : EDEHistoryModal,
    "EDEStatementModal" : EDEStatementModal,
    "FirstTimeLoginModal" : FirstTimeLoginModal,
    "DeletePhoneModal" : DeletePhoneModal,
    "DeleteEmailModal" : DeleteEmailModal,
    "AddContactMethodModal" : AddContactMethodModal,
    "CheckImagePreviewModal" : CheckImagePreviewModal,
    "MobileAccountDetailsModal" : MobileAccountDetailsModal,
    "OneTimeACHModal": OneTimeACHModal,
    "ACHParticipantsModal": ACHParticipantsModal,
    "PassThruACHDetailsModal": PassThruACHDetailsModal,
    "TransactionInquiryModal": TransactionInquiryModal,
    "TASPositivePayCancelAddCheckModal": TASPositivePayCancelAddCheckModal,
    "MenuModal":MenuModal
};